import { Component } from '@angular/core';
import { InputComponent } from '../../utilities/input/input.component';
import { OtpFieldComponent } from '../../components/otp-field/otp-field.component';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { ButtonComponent } from '../../utilities/button/button.component';
import { GeneralService } from '../../services/general.service';

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [CommonModule, InputComponent, ButtonComponent],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss',
})
export class RegisterComponent {
  registerData: any = {
    firstName: '',
    lastName: '',
    emailAddress: '',
    phoneNumber: '',
    password: '',
    organizationName: '',
    registrationCountry: '',
    street: '',
    city: '',
    state: '',
    country: '',
    organizationPhoneNumber: '',
    organizationEmailAddress: '',
    websiteUrl: '',
  };
  verifyPassword: string = ''
  errors: any = {
    firstName: '',
    lastName: '',
    emailAddress: '',
    phoneNumber: '',
    password: '',
    verifyPassword: '',
    organizationName: '',
    registrationCountry: '',
    street: '',
    city: '',
    state: '',
    country: '',
    organizationPhoneNumber: '',
    organizationEmailAddress: '',
    websiteUrl: '',
  };
  otp: string = '';
  otpId: string = '';
  loading: boolean = false;
  texts: string[] = [
    'Secure Your Payments, Protect Your Customers',
    'Join Us in Safeguarding Card Data',
    'Register Now for Ultimate Card Security',
  ];
  currentText: string = '';
  isDeleting: boolean = false;
  loopIndex: number = 0;
  charIndex: number = 0;
  typingSpeed: number = 150;
  backspaceSpeed: number = 75;
  pauseTime: number = 1000;
  OTPState: boolean = false;
  registerPage: number = 1;

  constructor(
    private router: Router,
    private authService: AuthService,
    private notification: NzNotificationService,
    private generalService: GeneralService
  ) {}

  ngOnInit(): void {
    this.startTypingEffect();
  }
  toNextStep = () => {
    if (Object.keys(this.firstStepValidation()).length > 0) {
      this.errors = { ...this.errors, ...this.firstStepValidation() };
    } else {
    this.registerPage++;
    }
  };
  toPreviousStep=()=>{
    this.registerPage--;
  }

  routeTo = (route: string) => {
    this.router.navigate([`/${route}`]);
  };

  handleInput(data: { title: string; value: string }) {
    this.registerData[data.title] = data.value;
    if(data.title === 'verifyPassword'){this.verifyPassword = data.value}
    if (data.value === '') {
      this.errors[data.title] = 'Required*';
      return;
    }else if (data.title.includes('emailAddress')  && !this.validateEmail(data.value)) {
      this.errors[data.title] = 'Please use a valid email*';
    } else {
      this.errors[data.title] = '';
    }
  }
  formatPhoneNumber(phone: string): string {
    if (!phone) return '';
  
    let cleaned = phone.trim().replace(/\D/g, '');
  
    if (phone.startsWith('+234')) {
      return phone;
    }
  
    return `+234${cleaned}`;
  }
  
  
  setEmail = (value: string) => {
    this.registerData.emailAddress = value;
    if (value === '') {
      this.errors.emailAddress = 'Required*';
    } else if (!this.validateEmail(value)) {
      this.errors.emailAddress = 'Please use a valid email*';
    } else {
      this.errors.emailAddress = '';
    }
  };
  firstStepValidation = () => {
    // console.log(this.registerData, this.verifyPassword);
    const errors: any = {};
    if (this.registerData.firstName === '') {
      errors.firstName = 'Required*';
    }
    if (this.registerData.lastName === '') {
      errors.lastName = 'Required*';
    }
    if (this.registerData.emailAddress === '') {
      errors.emailAddress = 'Required*';
    } else if (!this.validateEmail(this.registerData.emailAddress)) {
      errors.emailAddress = 'Please use a valid email*';
    }
    if (this.registerData.phoneNumber === '') {
      errors.phoneNumber = 'Required*';
    }
    else if(this.registerData.phoneNumber.length !< 8){
      errors.phoneNumber = 'Phone number must be valid*'
    }
    if (this.registerData.password === '') {
      errors.password = 'Required*';
    }
    if (this.verifyPassword === '') {
      errors.verifyPassword = 'Required*';
    } else if (this.verifyPassword !== this.registerData.password){
      errors.verifyPassword = 'Passwords must match*';
    }
    console.log(errors);
    return errors;
  };
  // organizationName: '',
  // registrationCountry: '',
  // street: '',
  // city: '',
  // state: '',
  // country: '',
  // organizationPhoneNumber: '',
  // organizationEmailAddress: '',
  // websiteUrl: '',
  secondStepValidation = () => {
    const errors: any = {};
    if (this.registerData.organizationName === '') {
      errors.organizationName = 'Required*';
    }
    if (this.registerData.registrationCountry === '') {
      errors.registrationCountry = 'Required*';
    }
    if (this.registerData.street === '') {
      errors.street = 'Required*';
    }
    if (this.registerData.city === '') {
      errors.city = 'Required*';
    }
    if (this.registerData.state === '') {
      errors.state = 'Required*';
    }
    if (this.registerData.state === '') {
      errors.state = 'Required*';
    }
    if (this.registerData.country === '') {
      errors.country = 'Required*';
    }
    if (this.registerData.websiteUrl === '') {
      errors.websiteUrl = 'Required*';
    }
    if (this.registerData.organizationPhoneNumber === '') {
      errors.organizationPhoneNumber = 'Required*';
    }
    else if(this.registerData.organizationPhoneNumber.length !< 8){
      errors.organizationPhoneNumber = 'Phone number must be valid*';
    }
    if (this.registerData.organizationEmailAddress === '') {
      errors.organizationEmailAddress = 'Required*';
    } else if (!this.validateEmail(this.registerData.organizationEmailAddress)) {
      errors.organizationEmailAddress = 'Please use a valid email*';
    }
    console.log(errors);
    return errors;
  };
  validateEmail = (email: string) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  startTypingEffect(): void {
    const currentIndex = this.loopIndex % this.texts.length;
    const fullText = this.texts[currentIndex];

    if (this.isDeleting) {
      this.currentText = fullText.substring(0, this.charIndex--);
    } else {
      this.currentText = fullText.substring(0, this.charIndex++);
    }

    if (!this.isDeleting && this.charIndex === fullText.length) {
      setTimeout(() => (this.isDeleting = true), this.pauseTime);
    } else if (this.isDeleting && this.charIndex === 0) {
      this.isDeleting = false;
      this.loopIndex++;
      setTimeout(() => this.startTypingEffect(), this.pauseTime);
      return;
    }

    const speed = this.isDeleting ? this.backspaceSpeed : this.typingSpeed;
    setTimeout(() => this.startTypingEffect(), speed);
  }
  setOTP = (otp: any) => {
    this.otp = otp;
    if (this.otp.length == 6) {
      this.register();
    }
  };

  sendOTP = () => {
    if (Object.keys(this.secondStepValidation()).length > 0) {
      this.errors = { ...this.errors, ...this.secondStepValidation() };
    } else {
      this.loading = true;
      this.authService.register(this.registerData).subscribe(
        (res: any) => {
          if (res.statusCode === 200) {
            this.loading = false;
            console.log(res);
            this.OTPState = !this.OTPState;
            this.otpId = res.data.otpId;
            this.notification.success('Success', 'OTP Sent Successfuly', {
              nzClass: 'notification',
            });
          } else {
          }
        },
        (error) => {
          this.loading = false;
          this.notification.error('Error', 'Something went wrong', {
            nzClass: 'notification',
          });
        }
      );
    }
  };
  register = () => {
    if (Object.keys(this.secondStepValidation()).length > 0) {
      this.errors = { ...this.errors, ...this.secondStepValidation() };
    } else {
      this.loading = true;
    const data = {
      user: {
        firstName: this.registerData.firstName,
        lastName: this.registerData.lastName,
        emailAddress: this.registerData.emailAddress,
        password: this.registerData.password,
        phoneNumber: this.formatPhoneNumber(this.registerData.phoneNumber),
      },
      organization: {
        name: this.registerData.organizationName,
        registrationCountry: this.registerData.registrationCountry,
        address: {
          street: this.registerData.street,
          city: this.registerData.city,
          state: this.registerData.state,
          country: this.registerData.country,
        },
        emailAddress: this.registerData.organizationEmailAddress,
        phoneNumber: this.formatPhoneNumber(this.registerData.organizationPhoneNumber),
        websiteUrl: this.registerData.websiteUrl
      }
    }
    console.log(data);
    this.authService.register(data).subscribe(
      (res: any) => {
         this.notification.success(
          'Success',
          'Sign In Successful',
          { nzClass: 'notification' }
        );
         this.loading = false;
         this.generalService.routeTo('')
      },
      (error) => {
        this.loading = false;
      
        switch (error.status) {
          case 400:
            this.notification.error('Bad Request', 'Please check your input.', { nzClass: 'notification' });
            break;
          case 401:
            this.notification.error('Unauthorized', 'You are not authorized to perform this action.', { nzClass: 'notification' });
            break;
          case 404:
            this.notification.error('Not Found', 'The requested resource was not found.', { nzClass: 'notification' });
            break;
          case 409:
            this.notification.error('Conflict', 'A conflict occurred. This item might already exist.', { nzClass: 'notification' });
            break;
          case 500:
            this.notification.error('Server Error', 'Something went wrong on the server.', { nzClass: 'notification' });
            break;
          default:
            this.notification.error('Error', 'Something went wrong. Please try again.', { nzClass: 'notification' });
        }
      }
      
    );}
  };
}
